import React from "react";

import PduliSessionKonseling from "./views/parts/PduliSessionKonseling";

export default function PduliModul() {
  return <PduliSessionKonseling />;
}
